<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CTabs>
              <CTab :title="$t('factorProducts')">
                <WarehouseOutputFactorProducts/>

              </CTab>
              <CTab :title="$t('inBranchFactors')">
                <WarehouseOutputInsideFactors/>

              </CTab>
              <CTab :title="$t('deliveryFactors')">
                <WarehouseOutputDelivery/>
              </CTab>
              <CTab :title="$t('insideFactors')">
                <ExitInsiteOrders/>
              </CTab>

              <CTab :title="$t('platform')">
                <PlatformLoadout/>
              </CTab>

            </CTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="change_factor_status_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          {{ $t('sureToConfirm') }}
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_factor_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_factor_status_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import ExitInsiteOrders from "../inventory/ExitInsiteOrders";
import PlatformLoadout from "./PlatformLoadout";
import WarehouseOutputDelivery from "./WarehouseOutputDelivery";
import WarehouseOutputFactorProducts from "./WarehouseOutputFactorProducts.vue";
import WarehouseOutputInsideFactors from "./WarehouseOutputInsideFactors.vue";
export default {
  name: 'Login',
  components: {
    WarehouseOutputDelivery,
    ExitInsiteOrders,
    PlatformLoadout,
    WarehouseOutputFactorProducts,
    WarehouseOutputInsideFactors
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      active_tab: 0,
      start_date: '',
      end_date: '',
      exit_product_search: '',
      change_factor_status_modal: false,
      selected_status: 0,


      factor_checkbox_items_exit: [],

      exit_factor_inventory_items: [],
      exit_factors_inventory_fields: [

        {key: 'row_id', label: this.$t('tables.number'), _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:2%'},

        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
        {key: 'partyName', label: this.$t('customer'), _style: 'width:10%'},
        {key: 'placeName', label: this.$t('inventory'), _style: 'width:10%'},
        // {key: 'toziKonande', label: this.$t('driver'), _style: 'width:10%'},
        // {key: 'routeName', label: this.$t('route'), _style: 'width:10%'},

        // {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
        // {key: 'status', label: this.$t('DisabilityStatus'), _style: 'width:15%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
        {key: 'select', label: this.$t('tables.select'), _style: 'width:2%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      status_form: 0,
      check_all_factor_exit: false,
    }
  },
  mounted() {
    this.active_tab = parseInt(localStorage.getItem("inventory_operation_active_tab"));
    if (this.active_tab == null) {
      this.active_tab = 0;
    }
    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();


  },
  watch: {

    'active_tab': function () {
      localStorage.setItem("inventory_operation_active_tab", this.active_tab);
    },

    'check_all_factor_exit': function () {
      if (this.check_all_factor_exit) {
        this.factor_checkbox_items_exit = [];

        this.exit_factor_inventory_items.forEach((val) => {
          this.factor_checkbox_items_exit.push(val.recId);
        });
      } else {
        this.factor_checkbox_items_exit = [];
      }
    },


  },
  methods: {
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.recId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.recId});

    },
    print_data() {
      // Pass the element id here
      this.print_with_header('printMe_warehouse_output', 'printMe_warehouse_output_header'
          , 'printMe_warehouse_output_footer');
    },


    change_factor_status_data(index) {

      if (this.factor_checkbox_items_exit.length == 0) {
        return false;

      }
      this.change_factor_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('ProductId', -1);
      formData.append('Ids[]', this.factor_checkbox_items_exit[index]);


      formData.append('FacStatus', 2);

      axios.post('AddFactorPlatform', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (index < self.factor_checkbox_items_exit.length - 1) {
            self.change_factor_status_data(index + 1);
          } else {
            self.factor_checkbox_items_exit = []
            self.get_insite_lists();
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },


    get_all_data() {
      this.get_insite_lists()
    },

    get_insite_lists() {
      var self = this;

      const formData = new FormData();
      self.exit_factor_inventory_items = []

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('DeliveryType', 22);

      self.factor_checkbox_items_exit = []

      axios.post('GetDocsForCollection', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_factor_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
